import React from 'react';
import { useStratsContext } from '@/finsight/application/Strats/StratsContext';
import * as content from './content';
import styles from '@/finsight/ui/components/strats/Footnotes/footnotes.scss';

const Footnotes = () => {
  const { metadata: { absAssetClass } } = useStratsContext();
  return (
    <div className={ styles.footnotes } data-test="footnotesWrapper">
      { content[absAssetClass] ? content[absAssetClass]() : null }
    </div>
  );
};

export default Footnotes;
